import moment, { tz } from "moment-timezone";
import { config } from "../../../../config/environment";

export const BACKENDURL = config.apiBaseUrl;
// export const BACKENDURL = "http://localhost:4000";
export const GEOCODER_APIKEY = "a53483df33d54171a004ac67f838b3ea";
export const COUNTRIES_API_KEY = "aDZEc2VEaEpiaHA2WUlhVXhOdndBejI2ZXVjdnFydUozWHJFWlBQcA==";
export const COUNTRIES_BASE_URL = "https://api.countrystatecity.in/";

export const REGEX = {
  EMAIL: /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/,
  TAX: /^[A-Za-z0-9\- ]{8,15}$/,
  IBAN: /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/,
  ONLYNUMBERS: /^\d+$/,
  PINCODE: /^[a-zA-Z0-9]+$/,
  CHEQUE: /^\d{6}$/,
  NAME: /^[a-zA-Z ]*$/,
  HTTPS: /^(https?:\/\/www\.|https?:\/\/|www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+)(\/[^\s]*)?$/,
  LINKEDIN: /^https?:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-_%]+\/?$/,
  COMPANYNAME: /^[a-zA-Z0-9&@., ]+$/,
  ADDRESS: {
    TOWN: /^[A-Za-z\s\-]+$/,
    COUNTRY: /^[A-Za-z\s\-]+$/,
    STATE: /^[A-Za-z\s\-]+$/,
  },
};

export const UserContextKeys = {
  USER: "user",
};

export const CONSTANT_TIMEZONE = "Asia/Dubai";
export const CURRENT_TIMEZONE = moment.tz(tz.guess()).format("z");
export const CURRENT_TIMEZONE_TEXT = tz.guess();

export const CURRENCYCODE: any = {
  AUD: "$",
  AED: "د.إ",
  BDT: "৳",
  BTC: "₿",
  CAD: "$",
  CNY: "¥",
  CRC: "₡",
  ETH: "Ξ",
  EUR: "€",
  GBP: "£",
  GEL: "₾",
  HKD: "$",
  ILS: "₪",
  INR: "₹",
  JPY: "¥",
  KRW: "₩",
  LTC: "Ł",
  MXN: "$",
  NGN: "₦",
  NZD: "$",
  PHP: "₱",
  PLN: "zł",
  PYG: "₲",
  RUB: "₽",
  SGD: "$",
  THB: "฿",
  TRY: "₺",
  UAH: "₴",
  USD: "$",
  VND: "₫",
  XMR: "ɱ",
};
